import { msg } from '@gonfalon/messages/msg';
import { Tag, TagGroup, TagList } from '@launchpad-ui/components';

export function SkillsBetaTag() {
  return (
    <TagGroup aria-label={msg('aiConfigs.skillsBetaTag.featureStatusLabel')}>
      <TagList>
        <Tag size="small" variant="beta">
          {msg('aiConfigs.skillsBetaTag.beta')}
        </Tag>
      </TagList>
    </TagGroup>
  );
}
